<div
  class="w-full h-full flex-1 min-h-0 border border-secondary-border rounded-xl bg-component-inner overflow-hidden shadow-sm flex flex-col @container"
>
  @if (displayBrowserHeader()) {
    <div
      class="bg-alt-background border-b border-secondary-border px-4 py-2 flex items-center gap-2 shrink-0"
    >
      <div class="flex gap-1.5">
        <span class="w-3 h-3 rounded-full bg-danger block opacity-50"></span>
        <span class="w-3 h-3 rounded-full bg-warning block opacity-50"></span>
        <span class="w-3 h-3 rounded-full bg-success block opacity-50"></span>
      </div>

      <div
        class="bg-component-inner border border-secondary-border text-xs text-secondary-text rounded px-3 py-0.5 mx-auto w-1/2 @sm:w-1/3 text-center truncate select-none shadow-sm font-mono"
        i18n="@@htmlPreview.sandboxUrl"
      >
        {{ sandboxTitle() }}
      </div>
    </div>
  }

  @if (effectiveAllowSameOrigin() && iframeUrl()) {
    <iframe
      #sandboxIframe
      [src]="iframeUrl()"
      (load)="iframeLoaded()"
      class="w-full h-full flex-1 min-h-0 border-none bg-body-background"
      sandbox="allow-scripts allow-modals allow-popups allow-forms allow-downloads allow-same-origin"
      i18n-title="@@htmlPreview.sandboxTitle"
      title="AI Generated Preview Sandbox"
    >
    </iframe>
  } @else if (!effectiveAllowSameOrigin() && iframeSrcdoc()) {
    <iframe
      #sandboxIframe
      [srcdoc]="iframeSrcdoc()"
      (load)="iframeLoaded()"
      class="w-full h-full flex-1 min-h-0 border-none bg-body-background"
      sandbox="allow-scripts allow-modals allow-popups allow-forms allow-downloads"
      i18n-title="@@htmlPreview.sandboxTitle"
      title="AI Generated Preview Sandbox"
    >
    </iframe>
  }
</div>
